import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import Zendesk from 'react-zendesk';

import { useOrganizationProperties } from '@/modules/transaction/hooks';
import { useGetZendeskMessagingTokenQuery } from '@/modules/user/queries';

import { cleanUpZendesk } from './cleanUpZendesk';

// const KEY = '6dc4524f-b662-4015-be1c-5a7d75c73ce4';

const SETTINGS = {
  webWidget: {
    offset: { vertical: '50px' },
  },
};

export default () => {
  const [isMounted, setIsMounted] = useState(false);
  const { organizationProperties } = useOrganizationProperties();
  const { getZendeskMessagingToken } = useGetZendeskMessagingTokenQuery();
  const zendeskKey = useMemo(() => organizationProperties?.participantChatbotLink, [organizationProperties]);
  const zendeskSsoEnabled = useMemo(() => organizationProperties?.zendeskSsoEnabled, [organizationProperties]);

  const handleLoginUser = useCallback(async (callback: (token: string) => void) => {
    try {
      const token = await getZendeskMessagingToken();
      if (!token) return;
      callback(token);
    } catch (error) {
      console.error("[ZendeskMessenger] loginUser failed:", error);
    }
  }, [getZendeskMessagingToken]);

  const handleLoaded = useCallback(() => {
    if (!zendeskKey || !zendeskSsoEnabled) return;
    window?.zE?.('messenger', 'loginUser', handleLoginUser, (error: unknown) => {
      if (error) {
        console.error('[ZendeskMessenger] loginUser failed:', error);
      }
    });
  }, [handleLoginUser, zendeskKey, zendeskSsoEnabled]);

  useEffect(() => {
    if (zendeskKey) {
      setIsMounted(true);
    }
  }, [zendeskKey]);

  useLayoutEffect(() => {
    return () => {
      cleanUpZendesk();
      setIsMounted(false);
    };
  }, []);

  if (!zendeskKey || !isMounted) {
    return null;
  }

  return (
    <Zendesk
      defer
      key={zendeskKey}
      zendeskKey={zendeskKey}
      onLoaded={handleLoaded}
      {...SETTINGS}
    />
  );
};
